// AI-assisted: Claude 2026-08-08, human-reviewed: ausstehend
// Trainings-Session zentral: Persistenz in IndexedDB plus ein Fenster-Ereignis,
// damit die untere Navigation den Fortschrittsring live mitführen kann.
import { getMeta, setMeta } from "./idb"
import { progress, type QueueState } from "./workoutQueue"

const KEY = "trainingSession"
const EVT = "fithub:session"

export interface TrainingSession {
  dayId: string
  dayCode: string
  date: string
  queue: QueueState
  startedAt: number
  savedCount: number
  volumeSum: number
}

export async function loadSession(): Promise<TrainingSession | null> {
  const s = await getMeta(KEY)
  return s && typeof s === "object" && "queue" in (s as object) ? (s as TrainingSession) : null
}

export async function storeSession(s: TrainingSession | null): Promise<void> {
  await setMeta(KEY, s ?? undefined)
  window.dispatchEvent(new CustomEvent(EVT, { detail: s }))
}

export function onSession(fn: (s: TrainingSession | null) => void): () => void {
  const h = (e: Event) => fn(((e as CustomEvent).detail as TrainingSession | null) ?? null)
  window.addEventListener(EVT, h)
  return () => window.removeEventListener(EVT, h)
}

/** Anteil erledigter Übungen 0..1 — für den Ring um den Training-Knopf. */
export function sessionProgress(s: TrainingSession | null): number {
  if (!s) return 0
  const p = progress(s.queue)
  return p.total ? p.done / p.total : 0
}
